/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./uc-attachments.vue?vue&type=template&id=11daeac8&"
import script from "./uc-attachments.vue?vue&type=script&lang=ts&"
export * from "./uc-attachments.vue?vue&type=script&lang=ts&"
import style0 from "./uc-attachments.vue?vue&type=style&index=0&id=11daeac8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports